import React from 'react';
import { LazyImage } from '../../../project/lazy-image';

const LiveTextWidgetFooter = ({ linkText, linkUrl, patronLogo }) => {
    if (!linkUrl || !linkText) return null;

    return (
        <div className="live-text-widget-footer__footer">
            <a
                className="live-text-widget-footer__full-link"
                href={linkUrl}
                rel="noopener noreferrer"
            >{linkText}</a>
            {
                (patronLogo) &&
                <div className="live-text-widget-footer__patron of-contain">
                    <LazyImage image={patronLogo} />
                </div>
            }
        </div>
    );
};

export default LiveTextWidgetFooter;
